import { useMemo } from "react";
import { string } from "prop-types";
import styled from "styled-components/macro";

import { BREAKPOINT_WRAPPER, GOOGLE_API_KEY } from "../../constants";
import { getMapLocationQuery } from "../../helpers";
import { colors } from "../../styles/Styles.variables";

const getMapUrl = (address, city, name, placeId, state, zip) => {
  if (!GOOGLE_API_KEY) {
    return null;
  }

  const query = !!placeId
    ? `place_id:${encodeURIComponent(placeId)}`
    : getMapLocationQuery(address, city, name, state, zip);

  if (!query) {
    return null;
  }

  return `https://www.google.com/maps/embed/v1/place?key=${GOOGLE_API_KEY}
    &q=${query}`;
};

const MapEmbed = ({
  address,
  city,
  name,
  placeId,
  ratioDesktop,
  ratioMobile,
  state,
  zip,
  ...rest
}) => {
  const mapUrl = useMemo(
    () => getMapUrl(address, city, name, placeId, state, zip),
    [address, city, placeId, name, state, zip]
  );

  return !!mapUrl ? (
    <MapContainer
      ratioDesktop={ratioDesktop}
      ratioMobile={ratioMobile}
      {...rest}
    >
      <iframe frameBorder="0" src={mapUrl} title={`Map of ${name}`}></iframe>
    </MapContainer>
  ) : null;
};

MapEmbed.propTypes = {
  address: string.isRequired,
  city: string.isRequired,
  name: string.isRequired,
  placeId: string,
  state: string.isRequired,
  zip: string.isRequired,
};

MapEmbed.defaultProps = {
  ratioDesktop: 50.2581756,
  ratioMobile: 75.5287009,
};

const MapContainer = styled.div`
  background-color: ${colors.gray200};
  height: 0;
  overflow: hidden;
  padding: ${({ ratioMobile }) => ratioMobile}% 0 0 0 !important;
  position: relative;
  width: 100%;

  @media ${BREAKPOINT_WRAPPER} {
    padding-top: ${({ ratioDesktop }) => ratioDesktop}% !important;
  }

  > iframe {
    border: 0 none;
    bottom: 0;
    height: 100%;
    left: 0;
    margin: 0;
    padding: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`;

export default MapEmbed;
